<header id="masthead" class="site-header">
    <!-- header html start -->
    <div class="top-header">
       <div class="container">
          <div class="top-header-inner">
            <div class="header-contact text-left">
                <!-- <a href="tel:+01977259912">
                   <i aria-hidden="true" class="icon icon-phone-call2"></i>
                   <div class="header-contact-details">
                      <span class="contact-label">Para contacto vía telefónico :</span>
                      <h5 class="header-contact-no">+(506) 8868 4846</h5>
                   </div>
                </a> -->
             </div>

             <!-- Photo by <a href="https://unsplash.com/@jorgefdezsalas?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Jorge Fernández Salas</a> on <a href="https://unsplash.com/photos/gran-via-madrid-v8XeGZf8tcs?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Unsplash</a> -->
             <div class="site-logo text-center">
                <p class="site-title">
                   <a href="javascript: void(0)" (click)="goToPage('home')">
                      <img src="https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/71ceeedb-5297-4289-b246-87e594f0ff00/public" alt="Logo">
                   </a>
                </p>
             </div>

             <div class="header-icon text-right">

                <div class="header-search-icon d-inline-block" *ngIf="showShopping">
                    <a href="javascript: void(0)" [matMenuTriggerFor]="shopping">
                       <i aria-hidden="true" class="fas fa-shopping-cart"></i>
                    </a>
                 </div>

                <div class="header-search-icon d-inline-block" *ngIf="showSearch">
                   <a href="#">
                      <i aria-hidden="true" class="fas fa-search"></i>
                   </a>
                </div>
                <div class="offcanvas-menu d-inline-block" *ngIf="showBurger">
                   <a href="#">
                      <i aria-hidden="true" class="icon icon-burger-menu"></i>
                   </a>
                </div>
             </div>
          </div>
       </div>
    </div>
    <mat-menu #shopping="matMenu">
        <button mat-menu-item *ngFor="let item of getShoppingCart()">
           <span class="myrow">{{item.product}} -  ${{item.price}}</span>
        </button>
        <button mat-menu-item>
           <span class="myrow">Pagar</span>
        </button>
     </mat-menu>
 
     <mat-menu #social="matMenu">
        <button mat-menu-item><span class="myrow"><i class="fab fa-facebook-f" aria-hidden="true"></i>VoyJaleas</span></button>
        <button mat-menu-item><span class="myrow"><i class="fab fa-instagram" aria-hidden="true"></i>@voyjaleas</span></button>
        <button mat-menu-item><span class="myrow"><i class="fab fa-youtube" aria-hidden="true"></i>VoyJaleas</span></button>
        <button mat-menu-item><span class="myrow"><i class="fab fa-whatsapp" aria-hidden="true"></i>(+34) 602 52 31 56</span></button>
     </mat-menu>

     <div class="bottom-header">
        <div class="container">
           <div class="bottom-header-inner d-flex justify-content-between align-items-center">
              <div class="header-social social-icon">
                 <ul>
                    <li>
                       <a href="https://www.facebook.com/voyjaleas/" target="_blank">
                          <i class="fab fa-facebook-f" aria-hidden="true"></i>
                       </a>
                    </li>
                    <li>
                       <a href="https://www.instagram.com/voyjaleas/" target="_blank">
                          <i class="fab fa-instagram" aria-hidden="true"></i>
                       </a>
                    </li>
                    <li>
                       <a href="javascript: void(0)" [matMenuTriggerFor]="social">
                          <i class="fab fa-youtube" aria-hidden="true"></i>
                       </a>
                    </li>
                    <li>
                       <a href="javascript: void(0)" [matMenuTriggerFor]="social">
                          <i class="fab fa-whatsapp" aria-hidden="true"></i>
                       </a>
                    </li>
                 </ul>
              </div>
              <div class="navigation-container d-none d-lg-block">
                 <nav id="navigation" class="navigation">
                    <ul>
                     <li class="menu-item" (click)="goToPage('home')">
                        <a href="javascript: void(0)">Inicio
                        </a>
                     </li>
                        <li class="menu-item-has-children">
                           <a href="javascript: void(0)">Servicios
                           </a>
                           <ul>
                              <li>
                                 <a href="javascript: void(0)" (click)="goToPage('services')">Todos los servicios</a>
                              </li>
                              <!-- <li>
                                 <a href="javascript: void(0)" (click)="goToPage('finder')">Búsqueda de apartamento.</a>
                              </li>
                              <li>
                                 <a href="javascript: void(0)" (click)="goToPage('finder')">Búsqueda de habitación.</a>
                              </li> -->
                           </ul>
                        </li>
                        <!-- <li class="menu-item-has-children">
                            <a href="javascript: void(0)">Preguntas Frecuentes
                            </a>
                            <ul>
                               <li>
                                  <a href="javascript: void(0)" (click)="goToPage('faq')">Preguntas comunes</a>
                               </li>
                               <li>
                                  <a href="javascript: void(0)" (click)="scrollToElement('question')">Hacer pregunta</a>
                               </li>
                            </ul>
                        </li> -->
                       <li class="menu-item-has-children" *ngIf="false">
                          <a href="team">Nosotros</a>
                          <ul>
                             <li>
                                <a href="javascript: void(0)" (click)="scrollToElement('ourteam')">Sebastián Jiménez</a>
                             </li>
 
                             <li>
                                <a href="javascript: void(0)" (click)="scrollToElement('ourteam')">Felipe Hidalgo</a>
                             </li>
                          </ul>
                       </li>
                       <li class="menu-item">
                        <a href="javascript: void(0)" (click)="goToPage('home/testimonial')">Testimonios</a>
                     </li>
                    </ul>
                 </nav>
              </div>
             
              <div class="header-btn">
                 <a href="javascript: void(0)"  (click)="goToPage('contact')" class="round-btn">Contactar</a>
              </div>
           </div>
        </div>
     </div>
    <div class="mobile-menu-container"></div>
 </header>